import { render, staticRenderFns } from "./welcome1.vue?vue&type=template&id=e70c1260&scoped=true"
import script from "./welcome1.vue?vue&type=script&lang=js"
export * from "./welcome1.vue?vue&type=script&lang=js"
import style0 from "./welcome1.vue?vue&type=style&index=0&id=e70c1260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70c1260",
  null
  
)

export default component.exports